import { render, staticRenderFns } from "./device-form.vue?vue&type=template&id=2e1ffa10"
import script from "./device-form.vue?vue&type=script&lang=js"
export * from "./device-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e1ffa10')) {
      api.createRecord('2e1ffa10', component.options)
    } else {
      api.reload('2e1ffa10', component.options)
    }
    module.hot.accept("./device-form.vue?vue&type=template&id=2e1ffa10", function () {
      api.rerender('2e1ffa10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/Devices/device-form.vue"
export default component.exports